import { AxiosResponse } from 'axios';
import { NotesTextForm } from 'civil-status/components/notes-text/form';
import { HttpResponse } from 'shell/models/http-response';
import { NotesText } from 'shell/models/notes-text';

export const transformResponseNoteText = (
  response: AxiosResponse<HttpResponse<NotesText>>
): NotesTextForm => {
  const responseData = response.data.payload;
  return {
    title: responseData.titolo || '',
    text: responseData.annotazione || '',
    type: responseData.tipoAnnotazione || '',
  };
};
